export const routespath = [{
    createProjectDetails: "/project",
    home: "/",
  }];